import { addStyles } from 'ethcss'
import grid from 'blocks.simple/grid/grid.jcss'
import { IStyles } from '../../../theme'

const deviceSettingsAudioPlayer: IStyles = {
    switchWrapper: {
        display: 'flex',
        marginBottom: 20,
    },
    switchCaption: {
        display: 'flex',
        alignItems: 'center',
        marginLeft: 14,

        span: {
            marginRight: 6,
        },
    },
    tip: {
        fontSize: 12,
    },
    disabled: {
        opacity: 0.5,
    },
}

addStyles(deviceSettingsAudioPlayer)
export default deviceSettingsAudioPlayer
